
import React, { Component}  from 'react';

import { FormProvider, FormContext } from 'core/FormProvider';
import { UserContext } from 'components/User';
import Layout from 'components/Dashboard/Layout';
import { YellowButton } from 'ui/Button';
import { PointForm } from './Form';


export default class PointAdd extends Component {

  static contextType = UserContext;

  componentDidMount() {
    document.title = 'Новая точка';
  }

  onDetail = (item) => {
    this.props.history.push(`/point`);
  };

  render() {

    return (
      <FormProvider
        url={'catalog/point'}
        postSave={(item) => this.onDetail(item)}
        postSaveMessage={'Точка добавлена'}
        item={{
          department: this.context.data.department_active
        }}
      >
        <FormContext.Consumer>
        {context => {
          const { loading } = context;
          return (
            <Layout>
              <Layout.Header
                title={'Создание точки'}
                backUrl={'/point'}
              />

              <Layout.ContentSimple>
                <PointForm />

                <div className={'mt-30'}>
                  <YellowButton
                    onClick={(e) => context.handleSubmit(e)}
                    size={'large'}
                    disabled={loading}
                  >
                    Создать точку
                  </YellowButton>

                </div>
              </Layout.ContentSimple>
            </Layout>
          )
        }}
        </FormContext.Consumer>
      </FormProvider>
    )
  }
}
